export const GLOBAL_CONTEXT_VAR = '__prog_leasing_global__';
export const GLOBAL_FORM_VAR = '__prog_leasing_form_global__';
